/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventResponse } from './eventResponse';


export interface EventBackUpResponse { 
    /**
     * List of purged/deleted/restored events
     */
    records?: Array<EventResponse>;
    /**
     * Number of Event records purged/deleted/restored
     */
    records_removed?: number;
}

